import React from 'react';
import App from './App';
import Login from './Login';
import { Switch, Route } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { withAllContexts } from './AllContextsWrapper';
import AdminClientsPage from './Components/Pages/AdminClientsPage';
import AdminPluginPage from './Components/Pages/AdminPluginPage';
import AdminPluginsListPage from './Components/Pages/AdminPluginsListPage';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { ReactComponent as Logo } from './Assets/svg/logo.svg';
import { WifiOff, RefreshCw } from 'lucide-react';

class IsLoggedInClass extends React.Component {
  render() {
    let socketIO = this.props.socketIO;

    // 1. Loading / Initial Waiting State
    if (socketIO.isWaiting) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-6 font-sans">
          <div className="flex flex-col items-center max-w-sm w-full animate-fade-in text-center">
            <div className="relative mb-12">
              <div className="absolute inset-0 bg-splavma-teal/5 rounded-full blur-3xl animate-pulse scale-150"></div>
              <div className="relative w-24 h-24">
                <img src="/icon/apple-touch-icon.png" alt="Logo" className="w-full h-full object-contain" />
              </div>
            </div>

            <div className="mb-8 relative">
               <CircularProgress 
                size={48} 
                thickness={5}
                className="text-splavma-teal"
              />
            </div>

            <h2 className="text-xl font-black text-gray-900 tracking-tight mb-2">
              Pripájame sa k serveru
            </h2>
          </div>
        </div>
      );
    } 

    // 2. Connection Failed State (Not waiting anymore, but not connected)
    if (!socketIO.isConnected) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-6 font-sans">
          <div className="flex flex-col items-center max-w-sm w-full animate-fade-in text-center">
            <div className="relative mb-12">
              <img src="/icon/apple-touch-icon.png" alt="Logo" className="w-24 h-24 grayscale opacity-30 object-contain" />
            </div>

            <div className="p-8 bg-red-50 rounded-[40px] border border-red-100 flex flex-col items-center w-full">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                <WifiOff className="text-red-500" size={32} />
              </div>
              
              <h2 className="text-lg font-black text-red-900 mb-2 uppercase tracking-tight">
                Chyba pripojenia
              </h2>
              <p className="text-sm font-bold text-red-700/60 uppercase tracking-widest text-center mb-8 leading-relaxed">
                Server neodpovedá.<br/>Skontrolujte pripojenie.
              </p>

              <button 
                onClick={() => window.location.reload()}
                className="w-full text-xs font-black uppercase tracking-[0.2em] text-white bg-red-600 hover:bg-red-700 transition-colors h-14 rounded-full flex items-center justify-center gap-3 shadow-xl shadow-red-200"
              >
                <RefreshCw size={16} /> Skúsiť znova
              </button>
            </div>
          </div>
        </div>
      );
    }
    
    if (!socketIO.isLoggedIn) {
      return <Login />;
    }

    return (
      <Switch>
        <Route exact path="/admin/clients" component={AdminClientsPage} />
        <Route exact path="/admin/calendar/:id/plugins" component={AdminPluginsListPage} />
        <Route path="/admin/calendar/:id/plugins/:plugin" component={AdminPluginPage} />
        <Route path="/" component={App} />
      </Switch>
    );
  }
}

const IsLoggedIn = withAllContexts(IsLoggedInClass);

class AppWrapper extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      newVersionAvailable: false,
      waitingWorker: {},
      token: null
    };
  }

  componentDidMount() {
    serviceWorkerRegistration.register({ onUpdate: this.onServiceWorkerUpdate });
  };

  refreshAction = (key) => {
    return (
      <React.Fragment>
        <Button
          className="snackbar-button"
          size="small"
          onClick={this.updateServiceWorker}
          sx={{ fontWeight: 'bold', color: 'inherit' }}
        >
          {"Aktualizovať"}
        </Button>
      </React.Fragment>
    );
  };

  onServiceWorkerUpdate = registration => {
    this.setState({
      waitingWorker: registration && registration.waiting,
      newVersionAvailable: true
    })
  }

  updateServiceWorker = () => {
    const { waitingWorker } = this.state
    waitingWorker && waitingWorker.postMessage({ type: 'SKIP_WAITING' })
    this.setState({ newVersionAvailable: false })
    window.location.reload()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.newVersionAvailable && !prevState.newVersionAvailable) {
      enqueueSnackbar("K dispozícii je nová verzia aplikácie", {
        persist: true,
        variant: "info",
        action: this.refreshAction(),
        key: 'new-version-available'
      });
    }
  }

  render() {
    return <IsLoggedIn />;
  }
}

export default withAllContexts(AppWrapper);
